export const css = {
	root: '_3Pvmypil',
	avatarColor: 'bdPCyZah',
	avatarColorSecondary: 'QAvAIMvR',
	avatarOutline: '_3ntd3_R6',
	small: 'KPuBbYAe',
	medium: '_2nF6cyWl',
	large: 'PmJ_uLcU',
	circle: '_3qIK51UA',
	square: 'RZCyxQSZ',
	rounded: '_25g1nxGk',
	' _key': 'certwise-theme/dojo/avatar'
};

export default css;
